export const environment = {
  production: true,
  apiUrl: 'https://pre-prod.oghairstudio.com/api',
  storageUrl: 'https://oghairstudio.com/uploads/pre-prod',
};
